import React, { useState } from 'react';
import { Calendar } from 'primereact/calendar';

import { UiComponents } from "@simulanisindia/ui";
import { MRR } from '../../Constant/constant';

const { SimDropdownBasic } = UiComponents;
{/* <Calendar value={date} onChange={(e) => setDate(e.value)} view="month" dateFormat="mm/yy" /> */ }
const RevenueRateCard = ({ key, index = 0, name = "", options = [], data = 0, selectedValue = null, onOptionClick }) => {
  const RenderOption = options;
  const [date, setDate] = useState(null);

  return (
    <>
      <div className="stat-item" key={index} >
        <div className="statInfo-Parent">
          <p>{name}</p>
          {key === MRR ?
            <Calendar value={date} onChange={(e) => setDate(e.value)} view="month" dateFormat="mm/yy" />
            :
            <SimDropdownBasic
              className="linecheckbtn"
              labelIcon={selectedValue || `select ${name || ""}`}
              data={options || []}
              onOptionClick={(value) => onOptionClick(value)}
            />}
        </div>
        <h6> {data} </h6>
      </div>
    </>
  )
}

export default RevenueRateCard;
